import { useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';

import { Icon } from 'app/main/components';
import { ViewTableUtils, type ViewTableColumnsLayoutType } from 'app/main/components/page-layouts';

import { showInvoicesModuleEditDialog } from './components/InvoicesModuleEditDialog';

function EditButton({ row, updateRefresh }: { row: any; updateRefresh: VoidFunction }) {
	const dispatch = useDispatch();

	const onClick = () => dispatch(showInvoicesModuleEditDialog({ invoiceUid: row.inrw_invc_uid, updateRefresh }));

	return (
		<IconButton size="small" onClick={onClick}>
			<Icon icon="edit" />
		</IconButton>
	);
}

const getInvoicesModuleTableColumns: ViewTableColumnsLayoutType = ({ t, updateRefresh }) => [
	{
		field: 'invc_title',
		headerName: t('DETAILS_INVOICES_FIELD_TITLE'),
		minWidth: 125,
		renderCell: ViewTableUtils.renderCellWithTooltip,
		hideable: false
	},
	{
		field: 'invc_d_issue',
		headerName: t('DETAILS_INVOICES_FIELD_DATE_ISSUE'),
		minWidth: 125,
		renderCell: ViewTableUtils.renderDate,
		hideable: false
	},
	{
		field: 'comp_title',
		headerName: t('DETAILS_INVOICES_FIELD_COMPANY'),
		minWidth: 200,
		flex: 1,
		renderCell: ({ value, row }) =>
			ViewTableUtils.renderCellWithTooltip({ value, to: { module: 'companies', uid: row.invc_comp_uid } }),
		hideable: false
	},
	{
		field: 'invc_internalnumber',
		headerName: t('DETAILS_INVOICES_FIELD_INTERNALNUMBER'),
		minWidth: 120,
		renderCell: ViewTableUtils.renderCellWithTooltip,
		hideable: false
	},
	{
		field: 'inrw_description',
		headerName: t('INVOICES_ROWS_COLUMN_DESCRIPTION'),
		minWidth: 200,
		flex: 1,
		renderCell: ViewTableUtils.renderCellWithTooltip
	},
	{
		field: 'inst_title',
		headerName: t('DETAILS_INVOICES_FIELD_STATUS'),
		minWidth: 150,
		renderCell: ({ value, row }) => ViewTableUtils.renderSquareChip({ value, backgroundColor: row.inst_color })
	},
	{
		field: 'inty_title',
		headerName: t('DETAILS_INVOICES_FIELD_TYPE'),
		minWidth: 150,
		renderCell: ({ value, row }) => ViewTableUtils.renderSquareChip({ value, backgroundColor: row.inty_color })
	},
	{
		field: 'inrw_amount_final',
		type: 'number',
		headerName: t('INVOICES_ROWS_COLUMN_AMOUNT'),
		minWidth: 150,
		cellClassName: ({ row }) =>
			row.inty_group === 'expenses' ? 'font-semibold text-red-600' : 'font-semibold text-green-700',
		renderCell: ViewTableUtils.renderCurrency,
		hideable: false
	},
	{
		type: 'actions',
		field: 'actions',
		width: 40,
		renderCell: ({ row }) => <EditButton row={row} updateRefresh={updateRefresh} />,
		sortable: false
	}
];

export default getInvoicesModuleTableColumns;
